export default __webpack_public_path__ + "static/media/lock.b76e41e4.svg";